import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import HeroImg from "../../../../assets/images/hero.jpg";

const Hero: React.FC = () => {
  return (
    <div className="min-h-screen h-screen lg:h-[1000px] bg-gradient-to-b from-white to-[#DFEDF2] overflow-hidden">
      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 lg:pt-16 xl:pt-20 pb-6 sm:pb-8 lg:pb-16 text-center relative">
        <h1 className="text-[28px] sm:text-[36px] md:text-[48px] lg:text-5xl xl:text-6xl font-bold text-hColor leading-tight mb-3 sm:mb-4 lg:mb-6 px-2">
          Simplify fleet management,
          <br className="hidden sm:block" />
          <span className="sm:hidden"> </span>
          maximize profitability
        </h1>

        <p className="text-[16px] sm:text-[18px] lg:text-xl text-pColor mb-6 sm:mb-8 lg:mb-12 max-w-4xl mx-auto leading-relaxed px-4">
          Track vehicles, manage drivers, monitor maintenance, and optimize
          profits—all from one powerful platform.
        </p>

        <Link
          to="/sign-up"
          className="w-[160px] sm:w-[172px] h-[48px] sm:h-[52px] bg-primary hover:bg-primary/90 text-white px-4 sm:px-6 lg:px-8 py-3 rounded-lg font-medium text-[13px] sm:text-[14px] flex items-center space-x-2 mx-auto transition-colors group"
        >
          <span>Get started</span>
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
        </Link>
      </section>

      {/* Dashboard Preview with Background Circles */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        {/* Background Decorative Circles */}
        <div className="absolute inset-0 pointer-events-none mt-6">
          {/* Right circle - responsive positioning and sizing */}
          <div className="absolute -right-[300px] sm:-right-[200px] lg:-right-20 -top-[200px] sm:-top-[300px] lg:-top-40 w-[800px] sm:w-[1200px] lg:w-[1451px] h-[800px] sm:h-[1200px] lg:h-[100vw] rounded-full border border-[#BCBCBC]"></div>

          {/* Left circle - responsive positioning and sizing */}
          <div className="absolute -left-[250px] sm:-left-[150px] lg:left-8 -top-[150px] sm:-top-[250px] lg:-top-36 w-[600px] sm:w-[900px] lg:w-[1160px] h-[600px] sm:h-[900px] lg:h-[100vw] rounded-full border border-[#BCBCBC] mt-8 sm:mt-12 lg:mt-20"></div>
        </div>

        {/* Dashboard Image Container */}
        <div className="relative z-10">
          <div className="rounded-xl sm:rounded-2xl shadow-lg sm:shadow-2xl relative overflow-hidden">
            {/* Dashboard Image */}
            <div className="relative">
              <img
                src={HeroImg}
                alt="FleetPro Dashboard Interface"
                className="w-full h-full object-cover"
              />

              {/* Responsive fade effect at the bottom */}
              <div className="absolute top-[200px] sm:top-[300px] lg:top-[400px] left-0 right-0 h-24 sm:h-36 lg:h-48 bg-gradient-to-t from-[#DFEDF2] to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
